import React, {useState} from 'react';
import Search from './Search';
import Manager from './Manager';
import Teams from './Groups';
import Roles from './Roles';

const Filters = ({onChange, teams, managers, roles, userId}) => {
  const [currentFilters, setCurrentFilters] = useState({
    manager: '',
    role: '',
    team: '',
    searchKey: '',
  });

  const handleChange = (key, value, isDefault) => {
    const newFilters = {...currentFilters};
    newFilters[key] = value;
    setCurrentFilters(newFilters);

    const validFilters = Object.entries(newFilters).reduce(
      (a, [k, v]) => (v ? ((a[k] = v), a) : a),
      {}
    );

    if (isDefault) {
      return;
    }

    const filters = {};
    Object.keys(validFilters).forEach((filterKey) => {
      if (filterKey === 'user' || filterKey === 'manager') {
        filters[filterKey] = validFilters[filterKey]._id;
      } else if (filterKey === 'language') {
        filters[filterKey] = validFilters[filterKey].code;
      } else if (filterKey === 'date') {
        filters[filterKey] = new Date(validFilters[filterKey]).toISOString();
      } else if (filterKey === 'status') {
        if (
          validFilters[filterKey].status !== 'All' &&
          validFilters[filterKey].status !== 'Mine'
        ) {
          filters[filterKey] = validFilters[filterKey].status;
        }

        if (validFilters[filterKey] === 'Mine') {
          filters.user = userId;
        }
      } else {
        filters[filterKey] = validFilters[filterKey];
      }
    });

    onChange(filters);
  };
  return (
    <div className="d-flex align-items-start mt-4 filters-middle letop-view">
      <Teams
        options={teams}
        selected={currentFilters.team}
        setSelected={(e) => handleChange('team', e)}
      />
      <Manager
        options={managers}
        selected={currentFilters.manager}
        setSelected={(e) => handleChange('manager', e)}
      />

      <Search
        value={currentFilters.searchKey}
        onChange={(e) => {
          handleChange('searchKey', e);
        }}
      />

      <Roles
        options={roles.filter(
          (current) =>
            current.title === 'editor' ||
            current.title === 'admin' ||
            current.title === 'manager' ||
            current.title === 'master'
        )}
        selected={currentFilters.role}
        setSelected={(e) => handleChange('role', e)}
      />
    </div>
  );
};

export default Filters;
